export default __webpack_public_path__ + "static/media/trees.3e048369.webp";